// Mock data for Morea Dress Rental Ecuador
// Images are sourced from the official Morea Bogotá website
// Replace with final Canva images as needed
//
// Data structure for dresses:
// {
//   id: unique identifier (string)
//   name: dress name (string)
//   priceUSD: rental price in USD (number)
//   image: image URL (string)
//   type: dress type - "Largo" | "Corto" | "Gala" | "Diseñador" | "Estampado" | "Color plano"
//   occasions: array of occasions where the dress is suitable
//   tags: additional tags like "Favorito", "Diseñador"
//   isFavorite: whether to show in "Nuestros favoritos" (boolean)
// }

export const DRESS_TYPES = [
  'Todos',
  'Largos',
  'Cortos',
  'Gala',
  'Diseñador',
  'Estampados',
  'Colores planos'
];

export const OCCASION_TYPES = [
  'Cocktail',
  'Evento de día',
  'Evento de noche',
  'Evento en hacienda',
  'Graduación',
  'Playa',
  'Matrimonio',
  'Invitada'
];

// Map filter labels to actual data values
export const TYPE_FILTER_MAP = {
  'Todos': null,
  'Largos': 'Largo',
  'Cortos': 'Corto',
  'Gala': 'Gala',
  'Diseñador': 'Diseñador',
  'Estampados': 'Estampado',
  'Colores planos': 'Color plano'
};

export const dresses = [
  // FAVORITES
  {
    id: 'camila',
    name: 'Camila',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/7171/image_1920',
    type: 'Largo',
    occasions: ['Evento de noche', 'Graduación', 'Matrimonio', 'Invitada'],
    tags: ['Favorito', 'Color plano'],
    isFavorite: true
  },
  {
    id: 'ambar',
    name: 'Ambar',
    priceUSD: 70,
    image: 'https://www.moreadressrental.com/web/image/product.template/8247/image_1920',
    type: 'Largo',
    occasions: ['Evento de noche', 'Cocktail', 'Invitada', 'Matrimonio'],
    tags: ['Favorito', 'Color plano'],
    isFavorite: true
  },
  {
    id: 'malu',
    name: 'Malu',
    priceUSD: 75,
    image: 'https://www.moreadressrental.com/web/image/product.template/7147/image_1920',
    type: 'Largo',
    occasions: ['Evento de noche', 'Gala', 'Matrimonio', 'Invitada'],
    tags: ['Favorito', 'Color plano'],
    isFavorite: true
  },
  {
    id: 'austria',
    name: 'Austria',
    priceUSD: 95,
    image: 'https://www.moreadressrental.com/web/image/product.template/9185/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Favorito', 'Color plano'],
    isFavorite: true
  },
  {
    id: 'mora',
    name: 'Mora',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/8371/image_1920',
    type: 'Largo',
    occasions: ['Evento de día', 'Cocktail', 'Invitada', 'Evento en hacienda'],
    tags: ['Favorito', 'Color plano'],
    isFavorite: true
  },
  {
    id: 'rafaela',
    name: 'Rafaela',
    priceUSD: 70,
    image: 'https://www.moreadressrental.com/web/image/product.template/8227/image_1920',
    type: 'Corto',
    occasions: ['Cocktail', 'Evento de día', 'Invitada'],
    tags: ['Favorito', 'Color plano'],
    isFavorite: true
  },
  {
    id: 'wayra',
    name: 'Wayra',
    priceUSD: 145,
    image: 'https://www.moreadressrental.com/web/image/product.template/7414/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Favorito', 'Diseñador'],
    isFavorite: true
  },
  {
    id: 'complete',
    name: 'Complete',
    priceUSD: 145,
    image: 'https://www.moreadressrental.com/web/image/product.template/8322/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Favorito', 'Diseñador'],
    isFavorite: true
  },
  {
    id: 'oriana',
    name: 'Oriana',
    priceUSD: 145,
    image: 'https://www.moreadressrental.com/web/image/product.template/7648/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Favorito', 'Diseñador'],
    isFavorite: true
  },
  {
    id: 'mageia',
    name: 'Mageia',
    priceUSD: 110,
    image: 'https://www.moreadressrental.com/web/image/product.template/8139/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Graduación'],
    tags: ['Favorito', 'Color plano'],
    isFavorite: true
  },
  {
    id: 'arte',
    name: 'Arte',
    priceUSD: 145,
    image: 'https://www.moreadressrental.com/web/image/product.template/7677/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Favorito', 'Diseñador', 'Estampado'],
    isFavorite: true
  },

  // CATALOG (non-favorites)
  {
    id: 'selva',
    name: 'Selva',
    priceUSD: 130,
    image: 'https://www.moreadressrental.com/web/image/product.template/9300/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Diseñador', 'Estampado'],
    isFavorite: false
  },
  {
    id: 'nassim-azul',
    name: 'Nassim Azul',
    priceUSD: 110,
    image: 'https://www.moreadressrental.com/web/image/product.template/9299/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'nassim-cafe',
    name: 'Nassim Café',
    priceUSD: 110,
    image: 'https://www.moreadressrental.com/web/image/product.template/9298/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'lorenza',
    name: 'Lorenza',
    priceUSD: 70,
    image: 'https://www.moreadressrental.com/web/image/product.template/9297/image_1920',
    type: 'Largo',
    occasions: ['Evento de noche', 'Cocktail', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'teresa',
    name: 'Teresa',
    priceUSD: 55,
    image: 'https://www.moreadressrental.com/web/image/product.template/9296/image_1920',
    type: 'Largo',
    occasions: ['Evento de día', 'Evento en hacienda', 'Invitada', 'Matrimonio'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'cami',
    name: 'Cami',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9295/image_1920',
    type: 'Corto',
    occasions: ['Cocktail', 'Evento de noche', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'lina-blanco',
    name: 'Lina Blanco',
    priceUSD: 50,
    image: 'https://www.moreadressrental.com/web/image/product.template/9293/image_1920',
    type: 'Corto',
    occasions: ['Evento de día', 'Cocktail', 'Graduación', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'lina-negro',
    name: 'Lina Negro',
    priceUSD: 50,
    image: 'https://www.moreadressrental.com/web/image/product.template/9292/image_1920',
    type: 'Corto',
    occasions: ['Cocktail', 'Evento de noche', 'Graduación'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'serena-verde',
    name: 'Serena Verde',
    priceUSD: 80,
    image: 'https://www.moreadressrental.com/web/image/product.template/9291/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'ramona',
    name: 'Ramona',
    priceUSD: 85,
    image: 'https://www.moreadressrental.com/web/image/product.template/9290/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'sandra',
    name: 'Sandra',
    priceUSD: 85,
    image: 'https://www.moreadressrental.com/web/image/product.template/9257/image_1920',
    type: 'Largo',
    occasions: ['Evento de día', 'Evento en hacienda', 'Invitada', 'Matrimonio'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'serena-pistacho',
    name: 'Serena Pistacho',
    priceUSD: 75,
    image: 'https://www.moreadressrental.com/web/image/product.template/9256/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Matrimonio', 'Invitada', 'Evento de día'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'taylor',
    name: 'Taylor',
    priceUSD: 70,
    image: 'https://www.moreadressrental.com/web/image/product.template/9255/image_1920',
    type: 'Gala',
    occasions: ['Gala', 'Evento de noche'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'ronie',
    name: 'Ronie',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9254/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Cocktail'],
    tags: ['Diseñador', 'Estampado'],
    isFavorite: false
  },
  {
    id: 'leticia',
    name: 'Leticia',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9253/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'lula',
    name: 'Lula',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9252/image_1920',
    type: 'Largo',
    occasions: ['Cocktail', 'Evento de noche', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'marta',
    name: 'Marta',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9251/image_1920',
    type: 'Largo',
    occasions: ['Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'cami-azul',
    name: 'Cami Azul',
    priceUSD: 75,
    image: 'https://www.moreadressrental.com/web/image/product.template/9250/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'trufa',
    name: 'Trufa',
    priceUSD: 75,
    image: 'https://www.moreadressrental.com/web/image/product.template/9248/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Cocktail'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'kira',
    name: 'Kira',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9240/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'merlot',
    name: 'Merlot',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9239/image_1920',
    type: 'Largo',
    occasions: ['Evento de noche', 'Cocktail', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'lorena',
    name: 'Lorena',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9238/image_1920',
    type: 'Largo',
    occasions: ['Evento de noche', 'Gala', 'Cocktail'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'ambar-celeste',
    name: 'Ambar Celeste',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9237/image_1920',
    type: 'Largo',
    occasions: ['Evento de día', 'Matrimonio', 'Invitada', 'Evento en hacienda'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'wayra-olas',
    name: 'Wayra Olas',
    priceUSD: 145,
    image: 'https://www.moreadressrental.com/web/image/product.template/9236/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Diseñador'],
    isFavorite: false
  },
  {
    id: 'wayra-naranja',
    name: 'Wayra Naranja',
    priceUSD: 145,
    image: 'https://www.moreadressrental.com/web/image/product.template/9235/image_1920',
    type: 'Diseñador',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Diseñador'],
    isFavorite: false
  },
  {
    id: 'rocio',
    name: 'Rocio',
    priceUSD: 75,
    image: 'https://www.moreadressrental.com/web/image/product.template/9234/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Cocktail'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'lila',
    name: 'Lila',
    priceUSD: 65,
    image: 'https://www.moreadressrental.com/web/image/product.template/9233/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio', 'Invitada'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'luisa',
    name: 'Luisa',
    priceUSD: 95,
    image: 'https://www.moreadressrental.com/web/image/product.template/9232/image_1920',
    type: 'Largo',
    occasions: ['Gala', 'Evento de noche', 'Matrimonio'],
    tags: ['Color plano'],
    isFavorite: false
  },
  {
    id: 'salpico',
    name: 'Salpico',
    priceUSD: 95,
    image: 'https://www.moreadressrental.com/web/image/product.template/9231/image_1920',
    type: 'Estampado',
    occasions: ['Evento de día', 'Cocktail', 'Playa', 'Evento en hacienda'],
    tags: ['Estampado'],
    isFavorite: false
  }
];

// Helper function to get favorites only (Wayra, Oriana, Arte are excluded from public favorites)
const FAVORITES_EXCLUDED = new Set(['wayra', 'oriana', 'arte']);
export const featuredDresses = dresses.filter(
  (d) => d.isFavorite && !FAVORITES_EXCLUDED.has(d.id)
);

export const dressTypes = [
  {
    id: 1,
    name: 'Estampados',
    image: 'https://morea-dress-rental1.odoo.com/web/image/37353-7f4cafe4/Sesion%20Morea%20202300488-Edit.jpg'
  },
  {
    id: 2,
    name: 'Colores planos',
    image: 'https://morea-dress-rental1.odoo.com/web/image/40850-4e68a247/_JEI0325%201.jpg'
  },
  {
    id: 3,
    name: 'Largos',
    image: 'https://morea-dress-rental1.odoo.com/web/image/31138-30339ae3/IMG_1066.JPG'
  },
  {
    id: 4,
    name: 'Cortos',
    image: 'https://morea-dress-rental1.odoo.com/web/image/30888-c6919a3a/_JEI2944.jpg'
  },
  {
    id: 5,
    name: 'Gala',
    image: 'https://morea-dress-rental1.odoo.com/web/image/23625-27b75a61/JEI2288-819x1024.jpg'
  },
  {
    id: 6,
    name: 'Diseñador',
    image: 'https://morea-dress-rental1.odoo.com/web/image/33587-7c5be0b8/Morea%202304202300305-Editar.jpeg'
  }
];

export const occasions = [
  {
    id: 1,
    name: 'Cocktail',
    image: 'https://morea-dress-rental1.odoo.com/web/image/46601-0c6e984a/Morea-2304202300977-scaled.jpeg'
  },
  {
    id: 2,
    name: 'Evento de día',
    image: 'https://morea-dress-rental1.odoo.com/web/image/37345-69ee7b03/Sesion%20Morea%20202300025-Edit.jpg'
  },
  {
    id: 3,
    name: 'Evento de noche',
    image: 'https://morea-dress-rental1.odoo.com/web/image/37351-a857ddd6/Sesion%20Morea%20202300306-Edit.jpg'
  },
  {
    id: 4,
    name: 'Evento en hacienda',
    image: 'https://morea-dress-rental1.odoo.com/web/image/40451-94217c64/_JEI0078%201.jpg'
  },
  {
    id: 5,
    name: 'Graduación',
    image: 'https://morea-dress-rental1.odoo.com/web/image/38462-9fbd2a74/Morea00498%201.jpg'
  },
  {
    id: 6,
    name: 'Playa',
    image: 'https://morea-dress-rental1.odoo.com/web/image/37325-a616c10f/DSC00798.jpg'
  },
  {
    id: 7,
    name: 'Matrimonio',
    image: 'https://morea-dress-rental1.odoo.com/web/image/31160-443391db/IMG_1008.JPG'
  },
  {
    id: 8,
    name: 'Invitada',
    image: 'https://morea-dress-rental1.odoo.com/web/image/30020-7f2b5c9a/_JEI2473.jpg'
  }
];

export const locations = [
  {
    id: 1,
    city: 'Quito',
    address: 'Calle Irlanda, Edificio Aqualina, Quito, Ecuador',
    whatsapp: '+593991347783',
    whatsappDisplay: '+593 99 134 7783',
    mapUrl: 'https://maps.google.com/maps?q=Calle+Irlanda+Edificio+Aqualina+Quito+Ecuador&output=embed',
    mapsLink: 'https://maps.app.goo.gl/nWhNo1joMfeHCyeUA'
  },
  {
    id: 2,
    city: 'Guayaquil',
    address: 'Av. Joaquín José Orrantia González, Edificio Agora 21, Guayaquil, Ecuador',
    whatsapp: '+593939725888',
    whatsappDisplay: '+593 93 972 5888',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3987.032!2d-79.9072!3d-2.1482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMsKwMDgnNTMuNSJTIDc5wrA1NCcyNS45Ilc!5e0!3m2!1sen!2sec!4v1234567890'
  }
];

export const faqs = [
  {
    id: 1,
    question: '¿Morea vende vestidos?',
    answer: 'No. Morea es un showroom de alquiler de vestidos. Nuestro enfoque es que puedas usar un vestido especial para tu evento sin tener que comprarlo.'
  },
  {
    id: 2,
    question: '¿La atención es con cita?',
    answer: 'Sí. Atendemos con cita para ofrecer una experiencia más personalizada y organizada.'
  },
  {
    id: 3,
    question: '¿Puedo consultar disponibilidad por WhatsApp?',
    answer: 'Sí. Puedes elegir la sede de Quito o Guayaquil y escribirnos directamente por WhatsApp.'
  },
  {
    id: 4,
    question: '¿Puedo ver vestidos antes de agendar?',
    answer: 'Sí. Puedes revisar los vestidos destacados y escribirnos para consultar disponibilidad, tallas y fechas.'
  }
];

export const rentalSteps = [
  {
    id: 1,
    title: 'Agenda tu cita',
    description: 'Reserva tu cita en nuestro showroom de Quito o Guayaquil a través de WhatsApp o nuestro sistema de reservas.'
  },
  {
    id: 2,
    title: 'Visita el showroom',
    description: 'Ven a nuestro showroom en la fecha y hora acordada para recibir atención personalizada.'
  },
  {
    id: 3,
    title: 'Elige y reserva',
    description: 'Pruébate los vestidos, recibe asesoría de estilo y reserva tu vestido favorito para tu evento.'
  },
  {
    id: 4,
    title: 'Retira, usa y devuelve',
    description: 'Retira tu vestido el día acordado, brilla en tu evento y devuélvelo después de usarlo.'
  }
];

export const heroImages = [
  'https://morea-dress-rental1.odoo.com/web/image/23625-27b75a61/JEI2288-819x1024.jpg',
  'https://morea-dress-rental1.odoo.com/web/image/31138-30339ae3/IMG_1066.JPG',
  'https://morea-dress-rental1.odoo.com/web/image/30888-c6919a3a/_JEI2944.jpg'
];

export const instagramHandle = '@morea_dressrental.ec';
export const bookingLink = 'https://linktr.ee/Morea_dressrentalEC';

// Accessories — curated from Morea Bogotá catalog + premium editorial images.
// Categories: Bolsos, Tacones, Aretes.
// Prices converted from COP to USD approx:
//   60,000 COP ≈ $17 | 70,000 COP ≈ $20 | 80,000 COP ≈ $22 | 100,000 COP ≈ $28
// Replace any placeholder image with the final Morea Ecuador image when available.
export const ACCESSORY_CATEGORIES = ['Todos', 'Bolsos', 'Tacones', 'Aretes'];

export const accessories = [
  // BOLSOS (carteras/clutches from Morea Bogotá)
  {
    id: 'bolso-sobre-champana',
    name: 'Sobre champaña',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9289/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-tejida-aros-plateada',
    name: 'Tejida aros plateada',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9288/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-aros-dorada',
    name: 'Aros dorada',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9287/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-sobre-plateada',
    name: 'Sobre plateada',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9286/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-tejida-perla',
    name: 'Tejida perla',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9285/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-oro-rosa',
    name: 'Oro rosa',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9284/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-tejida-negra',
    name: 'Tejida negra',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9283/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-tejida-vino',
    name: 'Tejida vino',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9282/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-dorada-lazo',
    name: 'Dorada con lazo',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9281/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-noche-brillante',
    name: 'Noche brillante',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9280/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-cristal-murano',
    name: 'Cristal murano',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9277/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-brillante-plateado',
    name: 'Brillante plateado',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9276/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-oro-rosa-rect',
    name: 'Brillante oro rosa',
    priceUSD: 17,
    image: 'https://www.moreadressrental.com/web/image/product.template/9275/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-dorada-mano',
    name: 'Dorada de mano',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9270/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-plateada-espejo',
    name: 'Plateada espejo',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9268/image_1920',
    category: 'Bolsos'
  },
  {
    id: 'bolso-espejo-dorada',
    name: 'Espejo dorada',
    priceUSD: 20,
    image: 'https://www.moreadressrental.com/web/image/product.template/9262/image_1920',
    category: 'Bolsos'
  },

  // TACONES (placeholder premium editorial images — replace with Morea Ecuador photos)
  {
    id: 'tacones-nude-clasicos',
    name: 'Nude clásicos',
    priceUSD: 22,
    image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=800&q=80',
    category: 'Tacones'
  },
  {
    id: 'tacones-negros-stiletto',
    name: 'Negros stiletto',
    priceUSD: 22,
    image: 'https://images.unsplash.com/photo-1535043934128-cf0b28d52f95?w=800&q=80',
    category: 'Tacones'
  },
  {
    id: 'tacones-dorados-correa',
    name: 'Dorados con correa',
    priceUSD: 25,
    image: 'https://images.unsplash.com/photo-1582897085656-c636d006a246?w=800&q=80',
    category: 'Tacones'
  },
  {
    id: 'tacones-plateados-tira',
    name: 'Plateados con tira',
    priceUSD: 25,
    image: 'https://images.unsplash.com/photo-1599643477877-530eb83abc8e?w=800&q=80',
    category: 'Tacones'
  },
  {
    id: 'tacones-blancos-elegantes',
    name: 'Blancos elegantes',
    priceUSD: 22,
    image: 'https://images.unsplash.com/photo-1573100925118-870b8efc799d?w=800&q=80',
    category: 'Tacones'
  },
  {
    id: 'tacones-rojos-fiesta',
    name: 'Rojos para fiesta',
    priceUSD: 25,
    image: 'https://images.unsplash.com/photo-1518894781321-630e638d0742?w=800&q=80',
    category: 'Tacones'
  },

  // ARETES (placeholder premium editorial images — replace with Morea Ecuador photos)
  {
    id: 'aretes-perlas-largos',
    name: 'Perlas largos',
    priceUSD: 17,
    image: 'https://images.unsplash.com/photo-1635767798638-3e25273a8236?w=800&q=80',
    category: 'Aretes'
  },
  {
    id: 'aretes-dorados-statement',
    name: 'Dorados statement',
    priceUSD: 17,
    image: 'https://images.unsplash.com/photo-1620656798932-902464fa5f44?w=800&q=80',
    category: 'Aretes'
  },
  {
    id: 'aretes-plateados-lluvia',
    name: 'Plateados lluvia',
    priceUSD: 17,
    image: 'https://images.unsplash.com/photo-1631982690223-8aa4be0a2497?w=800&q=80',
    category: 'Aretes'
  },
  {
    id: 'aretes-cristales',
    name: 'Cristales brillantes',
    priceUSD: 20,
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80',
    category: 'Aretes'
  },
  {
    id: 'aretes-aros-dorados',
    name: 'Aros dorados',
    priceUSD: 17,
    image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80',
    category: 'Aretes'
  },
  {
    id: 'aretes-flores-perla',
    name: 'Flores con perla',
    priceUSD: 20,
    image: 'https://images.unsplash.com/photo-1629224316810-9d8805b95e76?w=800&q=80',
    category: 'Aretes'
  }
];
